import React from 'react';
import { Link } from 'react-router-dom';
import './article.css';
import featuredImg from '../../assets/ib group photo 2026.jpg';

const Article = () => {
  return (
    <div className="article">
      <div className="article-img">
        <img src={featuredImg} alt="Featured"/>
      </div>
      <div className="article-whatwedo">
        <div className="article-whatwedo-title">
        Welcome to International Buddy!
        </div>
        <div className="article-whatwedo-content">
          <p>Hello! We are International Buddy, a non-profit organization in the greater Seattle area dedicated to improving the quality of life of neurodivergent youth. We foster an inclusive, accessible, and welcoming community where children and youth of all ages are empowered to reach their full potential.</p>
          <p>Check out more details <Link to="/whatwedo" className="article-link">about us</Link>.</p>
          <p>Looking for ways to help your local community? A fantastic way to start is by volunteering at IB! Volunteers regularly spend time with neurodivergent children and families to build their social skills and tutor them in various subject areas. We host a number of fun <Link to="/upcomingevents" className="article-link">events and activities</Link> every week!</p>
          <p><Link to="/login" className="article-link">Sign up</Link> to participate in volunteering opportunities today!</p>
        </div>
      </div>
    </div>
  )
}

export default Article